// Projects.js
import React, { useEffect, useState } from 'react';
import './project.css'
import OtherProjects from './OtherProjects';
const Projects = () => {
  const [activeFilter, setActiveFilter] = useState('');
  const allProjects = [
    {
      id: 8,
      title: 'AI Research Assistant',
      description: 'Agentic assistant processes PDFs, YouTube lectures, and web articles to answer queries with source citations using LangChain and Groq LLM',
      github: 'https://github.com/rohit0796/Reasearch-Asisstant-AI',
      tech: ["LangChain", "Groq LLM", "HuggingFace", "FAISS", "FastAPI", "React.js"],
      type: 'ai/ml'  // Added type for GenAI project
    },
    {
      id: 0,
      title: 'MedBot GEN-AI',
      description: 'Domain-specific Medical Science Chatbot powered by Generative AI using RAG (Retrieval-Augmented Generation) with LangChain and Groq API',
      github: 'https://github.com/rohit0796/MedBot-GEN-AI',
      tech: ["LangChain", "Groq API", "LLaMA 3", "FAISS", "Python", "Streamlit"],
      type: 'ai/ml'
    },
    {
      id: 1,
      title: 'Image Caption Generator',
      description: 'Generates descriptive captions for images using CNN (Xception) and LSTM on Flickr8k dataset',
      github: 'https://colab.research.google.com/drive/1Vc7DwKdi5gcfejfrNRQHkLJ-PxMLiUGd#scrollTo=wgT_Zl8hSWL9',
      tech: ["TensorFlow/Keras", "CNN", "LSTM", "Python"],
      type: 'ai/ml'
    },
    {
      id: 2,
      title: 'TravelBuddy',
      description: 'Cross-platform travel app for finding partners, trip planning, expense management with real-time chat',
      github: '#',
      link: 'https://play.google.com/store/apps/details?id=com.travelbuddy',
      tech: ["React Native", "Express.js", "MongoDB", "Socket.io"],
      type: 'mobile'
    },
    {
      id: 6,
      title: 'CollabFlow',
      description: 'Collaborative project management tool with task assignment, progress tracking, discussion forums, audio/video calling, and intuitive dashboard',
      github: 'https://github.com/rohit0796/CollabFlow',
      link: 'https://collabflow-82014.firebaseapp.com/',
      tech: ["React.js", "Tailwind css", "Firebase"],
      type: 'web'
    },
    {
      id: 7,
      title: 'Estate 360',
      description: 'Innovative land marketplace with cutting-edge features for buying and selling properties',
      github: 'https://github.com/rohit0796/Estate360',
      link: 'https://estate360-521e7.firebaseapp.com/',
      tech: ["React.js", "Firebase"],
      type: 'web'
    },
    {
      id: 3,
      title: 'StudySync',
      description: 'An all-in-one student management app empowering efficient note and todo storage, event scheduling, and attendance tracking.',
      github: 'https://github.com/rohit0796/StudySync',
      link: 'https://studentdetails-22389.web.app/',
      tech: ["React.js", "Node.js", "Express.js", "MongoDB"],
      type: 'web'
    },
    {
      id: 4,
      title: 'Chat App',
      description: 'Connecting conversations seamlessly: Your go-to chat app for real-time communication with friends and colleagues.',
      github: 'https://github.com/rohit0796/Chat-App',
      link: 'https://chat-app-tawny-delta.vercel.app/login',
      tech: ["MERN", 'Sockets', "WebRTC"],
      type: 'web'
    },
  ];
  const [filteredProjects, setFilteredProjects] = useState(allProjects)
  useEffect(() => {
    if (activeFilter == '') {
      setFilteredProjects(allProjects)
      return;
    }
    var filtProjects = allProjects.filter((projects) => {
      return projects.type == activeFilter
    })
    setFilteredProjects(filtProjects)
  }, [activeFilter])
  const handleTabClick = (tab) => {
    if (activeFilter == tab) setActiveFilter('')
    else setActiveFilter(tab)
  }
  return (
    <div className="project-cont">
      <h2 className="section-title">All Projects</h2>
      <div className="filter-tab-container">
        <div className={`tabs ${activeFilter == "web" ? "active" : ''}`} onClick={() => handleTabClick('web')}>Web</div>
        <div className={`tabs ${activeFilter == "ai/ml" ? "active" : ''}`} onClick={() => handleTabClick('ai/ml')}>AL/ML</div>
        <div className={`tabs ${activeFilter == "mobile" ? "active" : ''}`} onClick={() => handleTabClick('mobile')}>Mobile</div>
      </div>
      <div className="project-cards">
        {filteredProjects.map(project => (
          <OtherProjects key={project.id} project={project} />
        ))}
      </div>
    </div>
  );
};

export default Projects;
